import { render, staticRenderFns } from "./PublishErrorsModal.vue?vue&type=template&id=5cb019ac"
import script from "./PublishErrorsModal.vue?vue&type=script&lang=js"
export * from "./PublishErrorsModal.vue?vue&type=script&lang=js"
import style0 from "./PublishErrorsModal.vue?vue&type=style&index=0&id=5cb019ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports